import { render, staticRenderFns } from "./TaxSetting.vue?vue&type=template&id=2e24564f&scoped=true"
import script from "./TaxSetting.vue?vue&type=script&lang=js"
export * from "./TaxSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e24564f",
  null
  
)

export default component.exports